import React, { Component } from "react";
import { Dialog, IconButton, DialogContent, DialogTitle, Grid, Typography, Paper } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Draggable from "react-draggable";

import * as customColors from "../../theme/customColors";

// Original optional props:
// label
// maxWidth

// Extended optional props:
// children

function PaperComponent(props) {
  return (
    <Draggable handle="#customized-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

class CustomDialog extends Component {
  render() {
    const isCloseButtonVisible = !this.props.hideCloseButton;
    const dialog = (
        <Dialog
          disableEnforceFocus={this.props.disableEnforceFocus || false}
          fullWidth
          onClose={this.props.onClose}
          open={this.props.open}
          PaperProps={{ style: this.props.paperStyle, className: this.props.paperClassName }}
          PaperComponent={PaperComponent}
          maxWidth={this.props.maxWidth ? this.props.maxWidth : "sm"}>
          <DialogTitle
            style={{ background: customColors.darkBlue, cursor: "move", ...this.props.titleStyle }}
            id="customized-dialog-title"
          >
            <Grid container direction="row">
              <Grid item xs={isCloseButtonVisible ? 11 : 12}>
                <Typography
                  variant="h6"
                  align={this.props.titleAlign || "right"}
                  style={{ color: customColors.white, ...this.props.titleTypographyStyle }}
                >
                  {this.props.label}
                </Typography>
              </Grid>
              {isCloseButtonVisible ? (
                <Grid container item xs={1} justify="flex-end">
                  <Grid item>
                    <IconButton size="small" onClick={this.props.onClose} style={{ color: customColors.white }}>
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </DialogTitle>
          <DialogContent dividers={this.props.isContentDivided !== false} style={this.props.contentStyle}>
            {this.props.children}
          </DialogContent>
        </Dialog>
    );
    return dialog;
  }
}

export default CustomDialog;
